/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectUserData } from '../../Redux/UserSlice';
import { api_url } from '../../Constants/web_services';
import { useParams } from 'react-router-dom';
import '../../Assets/css/chat.css';
import moment from 'moment';
import Pusher from 'pusher-js';

function OrderChat() {
    const userData = useSelector(selectUserData);
    const { id: orderId } = useParams();
    const [order, setOrder] = useState();
    const [chat, setChat] = useState([]);
    const [messageInput, setMessageInput] = useState('');
    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(8);
    const [selectedImage, setSelectedImage] = useState(null);

    useEffect(() => {
        const fetchOrderDetails = async () => {
            try {
                const token = localStorage.getItem('token'); // Retrieve the token from local storage
                const response = await fetch(`${api_url}/api/user-profile/${userData?.id}/order-detail/${orderId}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
                    },
                });
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                const orderDetailData = await response.json();
                setOrder(orderDetailData?.data);
            } catch (error) {
                console.error("Error fetching order details:", error);
            }
        };

        fetchOrderDetails();
    }, [orderId, userData?.id]);

    useEffect(() => {
        fetchMessages(0, limit);
    }, [orderId, userData?.id]);

    const fetchMessages = async (offset, limit) => {
        try {
            const token = localStorage.getItem('token'); // Retrieve the token from local storage
            const response = await fetch(`${api_url}/api/getMessagesUser/${orderId}?offset=${offset}&limit=${limit}`, {
                headers: {
                    'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
                },
            });
            if (!response.ok) {
                throw new Error("Failed to fetch messages");
            }
            const chatData = await response.json();
            setChat(prevChat => [...prevChat, ...chatData.messages]);
            setOffset(prevOffset => prevOffset + limit);
            setLimit(8);
        } catch (error) {
            console.error("Error fetching messages:", error);
        }
    };

    const loadMoreMessages = () => {
        fetchMessages(offset, limit);
    };

    useEffect(() => {
        if (orderId) {
            Pusher.logToConsole = false;
            const pusher = new Pusher('71f5f5697ce5f5af59aa', {
                cluster: 'ap2',
                encrypted: true
            });

            const channel = pusher.subscribe(`chat.${orderId}`);

            channel.bind("App\\Events\\MessageSent", function (data) {
                setChat(prevChat => [data.message, ...prevChat]);
                const chatBox = document.querySelector('.chat-box');
                if (chatBox) {
                    chatBox.scrollTop = chatBox.scrollHeight;
                }
            });

            return () => {
                channel.unbind_all();
                channel.unsubscribe();
            };
        }
    }, [orderId]);

    const sendMessage = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append('message', messageInput);
            formData.append('order_id', order?.id);
            formData.append('user_id', userData?.id);
            formData.append('company_id', order?.company?.id);
            formData.append('sender_id', userData?.id);
            formData.append('image', selectedImage); // Include selected image in the request

            const token = localStorage.getItem('token'); // Retrieve the token from local storage

            const response = await fetch(`${api_url}/api/sendMessageUser`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
                },
                body: formData,
            });

            if (!response.ok) {
                throw new Error("Failed to send message");
            }
            setMessageInput('');
            setSelectedImage(null); // Reset selected image after sending
        } catch (error) {
            console.error("Error sending message:", error.message);
        }
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setSelectedImage(file);
    };
    return (
        <>
            <div id="content">
                <div className="content-admin-main my-5">
                    <div className="admin-top-area border-0 shadow-bx d-flex flex-wrap justify-content-center m-b30 align-items-center">
                        <h2>User Panel</h2>
                    </div>
                    <div className="aon-admin-heading">
                        <h2 className="s-16 fw-700 text-022279 text-center">Order Chat</h2>
                    </div>
                    <div className="card aon-card border-0 shadow">
                        <div className="card-header bg-transparent aon-card-header py-1">
                            <div className="row justify-content-between">
                                <div className="col-6 col-md-6">
                                    <h4 className="s-16 fw-700 text-022279 text-capitalize">
                                        <i className="fa fas fa-users-between-lines m-2" />
                                        {order?.order_no}
                                    </h4>
                                    <sup className="ml-5 fw-600 text-success text-capitalize"><u>Agent from SE</u></sup>
                                </div>
                                <div className="col-6 col-md-6">
                                    <h4 className="s-16 fw-700 text-022279 text-capitalize">
                                        <i className="fa fa-user m-2" />
                                        {userData?.username} Profile
                                    </h4>
                                    <sup className="ml-4 fw-600 text-success text-capitalize"><u>You can chat here</u></sup>
                                </div>
                            </div>
                        </div>
                        <div className="chat-box">
                            <div className="row justify-content-center">

                                <button className="loadMore col-3 text-center border-0 fw-700" type="button" onClick={loadMoreMessages}>Load More</button>
                            </div>

                            {[...chat].reverse().map((message, index, array) => (
                                <React.Fragment key={`message-container-${message.id}`}>
                                    {(index === 0 || array[index - 1].date !== message.date) && (
                                        <div className="row justify-content-between m-2" key={`message-timeline-${message.id}`}>
                                            <div className="col-5 p-0">
                                                <hr className='timeLine' />
                                            </div>
                                            <div className="col-2 p-0">
                                                <div className="message-date text-center fw-700">{moment(message.date).format('DD-MMM-YYYY')}</div>
                                            </div>
                                            <div className="col-5 p-0">
                                                <hr className='timeLine' />
                                            </div>
                                        </div>
                                    )}
                                    <div className={`message-container ${message.sender_id === message.company_id ? 'client' : 'you'}`}>
                                        <div className="message-content">
                                            {message?.image ? (
                                                <img src={api_url + '/' + message?.image} alt="no-img" className="img-fluid" style={{ maxWidth: '120px' }} />
                                            ) : (
                                                <span className={`ml-1 fw-700 ${message.sender_id === message.company_id ? '' : ''}`}>
                                                    {message.message}
                                                </span>
                                            )}
                                            <p className='p-0 row justify-content-end mr-1 mb-0 font-size-12'>
                                                {/* {moment(message.created_at).format('h:mm A')} */}
                                            </p>
                                        </div>
                                    </div>
                                </React.Fragment>
                            ))}
                        </div>


                        <form onSubmit={sendMessage}>
                            <div className="input-container">
                                <input
                                    type="text"
                                    id="message"
                                    placeholder="Type your message..."
                                    value={messageInput}
                                    onChange={(e) => setMessageInput(e.target.value)}
                                />
                                <div className="attachment-container">
                                    <label htmlFor="file-input">
                                        <i className="fa fa-paperclip attachment-icon" id="attachment-icon"></i>
                                    </label>
                                    <input type="file" id="file-input" name="image" className="file-input" onChange={handleImageChange} />
                                </div>
                                <button id="send-btn" type='submit' disabled={messageInput === " "}>Send</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default OrderChat;
